// @flow

import state from 'app/perf-utils/state';

export const reset = () => {
  state.reset();
};
